import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const occasion = async (id) => {
  try {
    return await getData(`/without-login/allOccasion`);
  } catch (error) {
    console.log(error);
  }
};

export const gratitude = async (id) => {
  try {
    return await getData(`/home/gratitude`);
  } catch (error) {
    console.log(error);
  }
};

export const HomeOffer = async (id) => {
  try {
    return await getData(`/policy/home-offers`);
  } catch (error) {
    console.log(error);
  }
};

export const banner = async (id) => {
  try {
    return await getData(`/home/banner`);
  } catch (error) {
    console.log(error);
  }
};

export const sustainable_products = async (id) => {
  try {
    return await getData(`/home/sustainable-products`);
  } catch (error) {
    console.log(error);
  }
};

export const promotional_products = async (id) => {
  try {
    return await getData(`/home/promotional-products`);
  } catch (error) {
    console.log(error);
  }
};

export const OccasionProducts = async (id) => {
  try {
    return await getData(`/home/occasion-products`);
  } catch (error) {
    console.log(error);
  }
};

export const blog = async (id) => {
  try {
    return await getData(`/home/promotional-products`);
  } catch (error) {
    console.log(error);
  }
};

export const bestSellingProduct = async (id) => {
  try {
    return await getData(`/without-login/all-best-selling-product`);
  } catch (error) {
    console.log(error);
  }
};

export const luxuryBanner = async (id) => {
  try {
    return await getData(`/luxury/home/banner`);
  } catch (error) {
    console.log(error);
  }
};

export const luxuryCategory = async (id) => {
  try {
    return await getData(`/luxury/home/category`);
  } catch (error) {
    console.log(error);
  }
};

export const luxuryHomeOccassion = async (id) => {
  try {
    return await getData(`/luxury/home/home-occassion`);
  } catch (error) {
    console.log(error);
  }
};


//Gift Occassion
export const luxuryGiftOccassion = async (id) => {
  try {
    return await getData(`/luxury/home/gift-occassion`);
  } catch (error) {
    console.log(error);
  }
};


export const luxuryAboutUs = async (id) => {
  try {
    return await getData(`/luxury/home/about-us-luxury`);
  } catch (error) {
    console.log(error);
  }
};

export const luxuryLatestNews = async (id) => {
  try {
    return await getData(`/luxury/latest-news`);
  } catch (error) {
    console.log(error);
  }
};
export const luxuryLatestNewsSigle = async (id) => {
  try {
    return await getData(`/luxury/latest-news/${id}`);
  } catch (error) {
    console.log(error);
  }
};
export const luxuryLatestNewsTrending = async (id) => {
  try {
    return await getData(`/luxury/latest-news/trending`);
  } catch (error) {
    console.log(error);
  }
};

export const luxuryPrivacyPolicy = async (id) => {
  try {
    return await getData(`/luxury/home/luxury-privacy-policy`);
  } catch (error) {
    console.log(error);
  }
};

export const luxuryTermCondition = async () => {
  try {
    return await getData(`/luxury/home/term-condition`);
  } catch (error) {
    console.log(error);
  }
};

export const luxuryDelivery = async () => {
  try {
    return await getData(`/luxury/home/delivery`);
  } catch (error) {
    console.log(error);
  }
};

export const luxuryResponsibilityPolicy = async (id) => {
  try {
    return await getData(`/luxury/home/luxury-responsibility-policy`);
  } catch (error) {
    console.log(error);
  }
};

export const luxuryLegalNotice = async (id) => {
  try {
    return await getData(`/luxury/home/luxury-legal-notice`);
  } catch (error) {
    console.log(error);
  }
};
